<template>
	<div class="container">
		<div class="pc-detail--map">
			<div class="map-wrap">
				<div class="pin" style="left: 100px; top: 100px">1</div>
			</div>
		</div>
		<div class="pc-detail--text type2">
			<ul class="list">
				<li class="item">
					<div class="num">1</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					332㎡ [100.43PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 09
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">2</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					463㎡ [140.30PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 04
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">3</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					451.2㎡ [136.49PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 06
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">4</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					172㎡ [52.03PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 03
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">5</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					695㎡ [210.8PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 12
				</li>
			</ul>
		</div>
		<div class="pc-detail--map">
			<div class="map-wrap">
				<div class="pin" style="left: 100px; top: 100px">6</div>
			</div>
		</div>
		<div class="pc-detail--text type2">
			<ul class="list">
				<li class="item">
					<div class="num">6</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					193.1㎡ [58.41PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 08
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">7</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					786㎡ [237.76PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 09
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">8</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					605.6㎡ [183.19PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 09
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">9</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					744.8㎡ [225.30PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 06
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">10</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					429.4㎡ [129.89PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 10
				</li>
			</ul>
			<ul class="list">
				<li class="item">
					<div class="num">11</div>
				</li>
				<li class="item">
					<label class="label">SPACE</label>
					468.5㎡ [141.72PY]
				</li>
				<li class="item">
					<label class="label">PURPOSE</label>
					Develop
				</li>
				<li class="item">
					<label class="label">DATE</label>
					2021. 11
				</li>
			</ul>
		</div>
	</div>
	<div class="footer">
		<div class="footer-wrap">
			<div class="footer-logo"></div>
			<div class="footer-info">
				<div class="line">
					<span>대표 : 서치원</span>
					<span>사업자 등록번호 : 395-87-02794</span>
					<span>주소 : 서울특별시 강남구 도산대로26길 20, 1층(논현동, NEWTURN빌딩)</span>
				</div>
				<div class="line">
					<span>대표번호 : 02-6956-2791</span>
					<span>팩스 : 070-4693-5728</span>
				</div>
			</div>
			<div class="footer-copy">
				개인정보처리방침<br />
				Copyrightⓒ2023 WEONUS All rights reserved.
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PC_Main',
	components: {},
	computed: {},
	data() {
		return {};
	},
	created() {},
	methods: {},
};
</script>
